// Dashboard
export const FETCH_DASHBOARD = 'fetch_dashboard';
// User
export const SET_USER = 'set_user';
export const CLEAN_USER = 'clean_user';
export const CHANGE_USER_SETTING = 'change_user_setting';
export const FETCH_USER_NOTIFICATIONS = 'fetch_user_notifications';
// Objednavky
export const FETCH_ORDERS = 'fetch_orders';
export const CLEAN_ORDERS = 'clean_orders';
export const SYNC_ORDER = 'sync_order';
export const SYNC_ORDERS = 'sync_orders';
export const EXPORT_ORDER = 'export_order';
export const EXPORT_ORDERS = 'export_orders';
export const CHANGE_ORDER_STATE = 'change_order_state';
export const CHANGE_ORDERS_STATE = 'change_orders_state';
export const CREATE_INVOICE = 'create_invoice';
export const CREATE_INVOICES = 'create_invoices';
export const PAID_ORDER = 'paid_order';
export const PAID_ORDERS = 'paid_orders';
export const DELETE_ORDER = 'delete_order';
export const DELETE_ORDERS = 'delete_orders';
export const ADDON_ORDERS = 'addon_orders';
export const EDIT_ORDER = 'edit_order';
export const SEND_ORDERS = 'send_orders';
export const SELLER_ORDER = 'seller_order';
export const SELLER_ORDERS = 'seller_orders';
export const PICKER_ORDER = 'picker_order';
export const EMAIL_ORDER = 'email_order';
// Klienti
export const FETCH_CLIENTS = 'fetch_clients';
export const CLEAN_CLIENTS = 'clean_clients';
export const DELETE_CLIENT = 'delete_client';
export const DELETE_CLIENTS = 'delete_clients';
export const CHANGE_CLIENT_NOTE = 'change_client_note';
// Faktury
export const FETCH_INVOICES = 'fetch_invoices';
export const CLEAN_INVOICES = 'clean_invoices';
export const DELETE_INVOICE = 'delete_invoice';
export const DELETE_INVOICES = 'delete_invoices';
// Platby
export const FETCH_INVOICE_PAYMENTS = 'fetch_invoice_payments';
export const CLEAN_INVOICE_PAYMENTS = 'clean_invoice_payments';
export const DELETE_INVOICE_PAYMENT = 'delete_invoice_payment';
export const DELETE_INVOICE_PAYMENTS = 'delete_invoice_payments';
export const ADDON_INVOICE_PAYMENTS = 'addon_invoice_payments';
// Stitky
export const FETCH_LABELS = 'fetch_labels';
export const CLEAN_LABELS = 'clean_labels';
export const DELETE_LABEL = 'delete_label';
export const DOWNLOAD_LABEL = 'download_label';
export const CREATE_COURIER = 'create_courier';
export const DELETE_COURIER = 'delete_courier';
// Exporty
export const FETCH_EXPORTS = 'fetch_exports';
export const CLEAN_EXPORTS = 'clean_exports';
export const DELETE_EXPORT = 'delete_export';
// Emaily
export const FETCH_TEMPLATES = 'fetch_templates';
export const CLEAN_TEMPLATES = 'clean_templates';
export const DELETE_TEMPLATE = 'delete_template';
export const TEMPLATE_UPLOAD_LOGO = 'template_upload_logo';
// Email
export const FETCH_TEMPLATE = 'fetch_template';
export const CLEAN_TEMPLATE = 'clean_template';
// Export
export const FETCH_EXPORT = 'fetch_export';
export const CLEAN_EXPORT = 'clean_export';
// Bmails
export const FETCH_BMAILS = 'fetch_bmails';
export const CLEAN_BMAILS = 'clean_bmails';
export const CREATE_GATEWAY = 'create_gateway';
export const DELETE_GATEWAY = 'delete_gateway';
export const CREATE_BANK = 'create_bank';
export const DELETE_BANK = 'delete_bank';
// Addony
export const FETCH_ADDONS = 'fetch_addons';
export const CLEAN_ADDONS = 'clean_addons';
export const CREATE_ADDON = 'create_addon';
export const DELETE_ADDON = 'delete_addon';
// Eshop
export const FETCH_ESHOP = 'fetch_eshop';
export const FETCH_ESHOP_DATA = 'fetch_eshop_data';
export const CHANGE_ESHOP_AUTO_FIELD = 'change_eshop_auto_field';
export const CHANGE_ESHOP_SETTINGS = 'change_eshop_settings';
export const CREATE_ESHOP = 'create_eshop';
// Ekonomicky system
export const FETCH_ACCOUNTING = 'fetch_accounting';
export const FETCH_ACCOUNTING_DATA = 'fetch_accounting_data';
export const CHANGE_ACCOUNTING_AUTO_FIELD = 'change_accounting_auto_field';
export const CHANGE_ACCOUNTING_SETTINGS = 'change_accounting_settings';
export const CREATE_ACCOUNTING = 'create_accounting';
export const DELETE_ACCOUNTING = 'delete_accounting';
// Sklad
export const FETCH_STORAGE = 'fetch_storage';
export const FETCH_STORAGE_DATA = 'fetch_storage_data';
export const CHANGE_STORAGE_AUTO_FIELD = 'change_storage_auto_field';
export const CHANGE_STORAGE_SETTINGS = 'change_storage_settings';
export const CREATE_STORAGE = 'create_storage';
export const DELETE_STORAGE = 'delete_storage';
// Zamestnanci
export const FETCH_EMPLOYEES = 'fetch_employees';
export const DELETE_EMPLOYEE = 'delete_employee';
export const CLEAN_EMPLOYEES = 'clean_employees';
// Zamestnanec
export const FETCH_EMPLOYEE = 'fetch_employee';
export const CLEAN_EMPLOYEE = 'clean_employee';
// Notifikacie
export const FETCH_NOTIFICATIONS = 'fetch_notifications';
export const CLEAN_NOTIFICATIONS = 'clean_notifications';
export const DELETE_NOTIFICATION = 'delete_notification';
export const DELETE_NOTIFICATIONS = 'delete_notifications';
export const READ_NOTIFICATION = 'read_notification';
export const READ_NOTIFICATIONS = 'read_notifications';
// Nastavenia
export const FETCH_SETTINGS = 'fetch_settings';
export const CLEAN_SETTINGS = 'clean_settings';
export const SAVE_SETTINGS = 'save_settings';
// Marketplaces
export const FETCH_MARKETPLACES = 'fetch_marketplaces';
export const CLEAN_MARKETPLACES = 'clean_marketplaces';
export const CREATE_MARKETPLACE = 'create_marketplace';
export const DELETE_MARKETPLACE = 'delete_marketplace';
// Admin
export const FETCH_ADMIN = 'fetch_admin';
export const CLEAN_ADMIN = 'clean_admin';
export const FETCH_ADMIN_PROCESS = 'fetch_admin_process';
export const FETCH_ADMIN_ERROR = 'fetch_admin_error';
// Menu
export const CHANGE_MOBILE_MENU = 'change_mobile_menu';
// Objednavka
export const FETCH_CREATE_ORDER = 'fetch_create_order';
export const CLEAN_ORDER = 'clean_order';
// Track trace
export const FETCH_TRACK_TRACE = 'fetch_track_trace';
export const CLEAN_TRACK_TRACE = 'clean_track_trace';
export const CHANGE_TRACK_TRACE_SETTINGS = 'change_track_trace_settings';
export const TRACK_TRACE_UPLOAD_LOGO = 'track_trace_upload_logo';
// Reklamacie
export const FETCH_COMPLAINTS = 'fetch_complaints';
export const CLEAN_COMPLAINTS = 'clean_complaints';
export const DELETE_COMPLAINT = 'delete_complaint';
export const DELETE_COMPLAINTS = 'delete_complaints';
export const CHANGE_COMPLAINT_STATUS = 'change_complaint_status';
export const SEND_COMPLAINTS = 'send_complaints';
// Reklamacia
export const FETCH_COMPLAINT = 'fetch_complaint';
export const CLEAN_COMPLAINT = 'clean_complaint';
// Mtokna sellers
export const FETCH_MTOKNA_SELLERS = 'fetch_mtokna_sellers';
export const CLEAN_MTOKNA_SELLERS = 'clean_mtokna_sellers';
export const CHANGE_MTOKNA_SELLER_EMAIL = 'change_mtokna_seller_email';
export const CHANGE_MTOKNA_SELLER_SMTP = 'change_mtokna_seller_smtp';
export const CHANGE_MTOKNA_SELLER_MARKET = 'change_mtokna_seller_market';
// Mtokna owners
export const FETCH_MTOKNA_OWNERS = 'fetch_mtokna_owners';
export const CLEAN_MTOKNA_OWNERS = 'clean_mtokna_owners';
export const CHANGE_MTOKNA_OWNER_EMAIL = 'change_mtokna_owner_email';
export const CHANGE_MTOKNA_OWNER_SETTINGS = 'change_mtokna_owner_settings';
export const CHANGE_MTOKNA_OWNER_MARKET = 'change_mtokna_owner_market';
// Mtokna points
export const FETCH_MTOKNA_POINTS = 'fetch_mtokna_points';
export const CLEAN_MTOKNA_POINTS = 'clean_mtokna_points';
export const CHANGE_MTOKNA_POINT = 'change_mtokna_point';
export const DELETE_MTOKNA_POINT = 'delete_mtokna_point';
export const CHANGE_MTOKNA_POINT_PAGE_STATUS = 'change_mtokna_point_page_status';
// Mtokna orders
export const FETCH_MTOKNA_ORDERS = 'fetch_mtokna_orders';
export const CLEAN_MTOKNA_ORDERS = 'clean_mtokna_orders';
export const SYNC_MTOKNA_ORDER = 'sync_mtokna_order';
export const EXPORT_MTOKNA_ORDER = 'export_mtokna_order';
export const EXPORT_MTOKNA_ORDERS = 'export_mtokna_orders';
export const CHANGE_MTOKNA_ORDER_STATE = 'change_mtokna_order_state';
export const SELLER_MTOKNA_ORDER = 'seller_mtokna_order';
export const SELLER_MTOKNA_ORDERS = 'seller_mtokna_orders';
export const READY_MTOKNA_ORDER = 'ready_mtokna_order';
export const LOCK_MTOKNA_ORDER = 'lock_mtokna_order';
export const UNLOCK_MTOKNA_ORDER = 'unlock_mtokna_order';
export const PICKUP_MTOKNA_ORDER = 'pickup_mtokna_order';
export const EDIT_MTOKNA_ORDER = 'edit_mtokna_order';
export const SEND_MTOKNA_ORDERS = 'send_mtokna_orders';
// Mtokna manual orders
export const FETCH_MTOKNA_MANUAL_ORDERS = 'fetch_mtokna_manual_orders';
export const CLEAN_MTOKNA_MANUAL_ORDERS = 'clean_mtokna_manual_orders';
export const EXPORT_MTOKNA_MANUAL_ORDER = 'export_mtokna_manual_order';
export const CHANGE_MTOKNA_MANUAL_ORDER_STATE = 'change_mtokna_manual_order_state';
export const EDIT_MTOKNA_MANUAL_ORDER = 'edit_mtokna_manual_order';
export const DELETE_MTOKNA_MANUAL_ORDER = 'delete_mtokna_manual_order';
export const CREATE_MTOKNA_MANUAL_INVOICE = 'create_mtokna_manual_invoice';
export const ADDON_MTOKNA_MANUAL_ORDERS = 'addon_mtokna_manual_orders';
export const SEND_MTOKNA_MANUAL_ORDERS = 'send_mtokna_manual_orders';
export const EXPORT_MTOKNA_MANUAL_ORDERS = 'export_mtokna_manual_orders';
// Emaily
export const FETCH_MTOKNA_TEMPLATES = 'fetch_mtokna_templates';
export const CLEAN_MTOKNA_TEMPLATES = 'clean_mtokna_templates';
// Email
export const FETCH_MTOKNA_TEMPLATE = 'fetch_mtokna_template';
export const CLEAN_MTOKNA_TEMPLATE = 'clean_mtokna_template';
// Emaily
export const FETCH_MTOKNA_NEWSLETTERS = 'fetch_mtokna_newsletters';
export const CLEAN_MTOKNA_NEWSLETTERS = 'clean_mtokna_newsletters';
export const DELETE_MTOKNA_NEWSLETTER = 'delete_mtokna_newsletter';
// Email
export const FETCH_MTOKNA_NEWSLETTER = 'fetch_mtokna_newsletter';
export const CLEAN_MTOKNA_NEWSLETTER = 'clean_mtokna_newsletter';
// Owner Smtp
export const FETCH_MTOKNA_OWNER_SMTP = 'fetch_mtokna_owner_smtp';
export const CLEAN_MTOKNA_OWNER_SMTP = 'clean_mtokna_owner_smtp';
// Mtokna eshop
export const FETCH_MTOKNA_ESHOP = 'fetch_mtokna_eshop';
export const CREATE_MTOKNA_ESHOP = 'create_mtokna_eshop';
// Aderyn products
export const FETCH_ADERYN_PRODUCTS = 'fetch_aderyn_products';
export const CLEAN_ADERYN_PRODUCTS = 'clean_aderyn_products';
export const CHANGE_ADERYN_PRODUCT = 'change_aderyn_product';
// Aderyn product logs
export const FETCH_ADERYN_PRODUCT_LOGS = 'fetch_aderyn_product_logs';
export const CLEAN_ADERYN_PRODUCT_LOGS = 'clean_aderyn_product_logs';
// Mtokna files
export const FETCH_MTOKNA_FILES = 'fetch_mtokna_files';
export const CLEAN_MTOKNA_FILES = 'clean_mtokna_files';
export const DELETE_MTOKNA_FILE = 'delete_mtokna_file';
// Cab products
export const FETCH_CAB_PRODUCTS = 'fetch_cab_products';
export const CLEAN_CAB_PRODUCTS = 'clean_cab_products';
export const ADD_CAB_UPGATES_PRODUCT = 'add_cab_upgates_product';
export const REMOVE_CAB_UPGATES_PRODUCT = 'remove_cab_upgates_product';
export const ADD_CAB_ALLEGRO_PRODUCT = 'add_cab_allegro_product';
export const REMOVE_CAB_ALLEGRO_PRODUCT = 'remove_cab_allegro_product';
export const ADD_CAB_MALL_PRODUCT = 'add_cab_mall_product';
export const REMOVE_CAB_MALL_PRODUCT = 'remove_cab_mall_product';
export const CHANGE_CAB_UPGATES_PRODUCT_PRICE = 'change_cab_upgates_product_price';
export const CHANGE_CAB_MARKETPLACE_PRODUCT_PRICE = 'change_cab_marketplace_product_price';
// Mtokna manual seller orders
export const FETCH_MTOKNA_MANUAL_SELLER_ORDERS = 'fetch_mtokna_manual_seller_orders';
export const CLEAN_MTOKNA_MANUAL_SELLER_ORDERS = 'clean_mtokna_manual_seller_orders';
export const EDIT_MTOKNA_MANUAL_SELLER_ORDER = 'edit_mtokna_manual_seller_order';
export const DELETE_MTOKNA_MANUAL_SELLER_ORDER = 'delete_mtokna_manual_seller_order';
export const CREATE_MTOKNA_MANUAL_SELLER_ORDER_INVOICE = 'create_mtokna_manual_seller_order_invoice';
export const EXPORT_MTOKNA_MANUAL_SELLER_ORDER = 'export_mtokna_manual_seller_order';
export const CHANGE_MTOKNA_MANUAL_SELLER_ORDER_STATE = 'change_mtokna_manual_seller_order_state';
export const READY_PICKUP_MTOKNA_MANUAL_SELLER_ORDER = 'ready_pickup_mtokna_manual_seller_order';
export const PICKUP_MTOKNA_MANUAL_SELLER_ORDER = 'pickup_mtokna_manual_seller_order';
export const ACTIVATE_MTOKNA_MANUAL_SELLER_ORDER = 'activate_mtokna_manual_seller_order';
// Mtokna banners
export const FETCH_MTOKNA_BANNERS = 'fetch_mtokna_banners';
export const CLEAN_MTOKNA_BANNERS = 'clean_mtokna_banners';
export const DELETE_MTOKNA_BANNER = 'delete_mtokna_banner';
export const CHANGE_MTOKNA_BANNER = 'change_mtokna_banner';
// Mtokna moderators
export const FETCH_MTOKNA_MODERATORS = 'fetch_mtokna_moderators';
export const CLEAN_MTOKNA_MODERATORS = 'clean_mtokna_moderators';
export const CHANGE_MTOKNA_MODERATOR_EMAIL = 'change_mtokna_moderator_email';
export const DELETE_MTOKNA_MODERATOR = 'delete_mtokna_moderator';
// Mtokna manual customer orders
export const FETCH_MTOKNA_MANUAL_CUSTOMER_ORDERS = 'fetch_mtokna_manual_customer_orders';
export const CLEAN_MTOKNA_MANUAL_CUSTOMER_ORDERS = 'clean_mtokna_manual_customer_orders';
export const EDIT_MTOKNA_MANUAL_CUSTOMER_ORDER = 'edit_mtokna_manual_customer_order';
export const DELETE_MTOKNA_MANUAL_CUSTOMER_ORDER = 'delete_mtokna_manual_customer_order';
export const CHANGE_MTOKNA_MANUAL_CUSTOMER_ORDER_STATE = 'change_mtokna_manual_customer_order_state';
export const READY_PICKUP_MTOKNA_MANUAL_CUSTOMER_ORDER = 'ready_pickup_mtokna_manual_customer_order';
export const PICKUP_MTOKNA_MANUAL_CUSTOMER_ORDER = 'pickup_mtokna_manual_customer_order';
export const ACTIVATE_MTOKNA_MANUAL_CUSTOMER_ORDER = 'activate_mtokna_manual_customer_order';
// Mtokna complaints
export const FETCH_MTOKNA_COMPLAINTS = 'fetch_mtokna_complaints';
export const CLEAN_MTOKNA_COMPLAINTS = 'clean_mtokna_complaints';
export const EDIT_MTOKNA_COMPLAINT = 'edit_mtokna_complaint';
export const DELETE_MTOKNA_COMPLAINT = 'delete_mtokna_complaint';
export const EXPORT_MTOKNA_COMPLAINT = 'export_mtokna_complaint';
export const CHANGE_MTOKNA_COMPLAINT_STATE = 'change_mtokna_complaint_state';
export const CANCEL_MTOKNA_COMPLAINT = 'cancel_mtokna_complaint';
// Mtokna categories
export const FETCH_MTOKNA_CATEGORIES = 'fetch_mtokna_categories';
export const CLEAN_MTOKNA_CATEGORIES = 'clean_mtokna_categories';
export const CHANGE_MTOKNA_CATEGORY = 'change_mtokna_category';
export const CHANGE_MTOKNA_CATEGORY_STATUS = 'change_mtokna_category_status';
export const DELETE_MTOKNA_CATEGORY = 'delete_mtokna_category';
// Mtokna products
export const FETCH_MTOKNA_PRODUCTS = 'fetch_mtokna_products';
export const CLEAN_MTOKNA_PRODUCTS = 'clean_mtokna_products';
export const CHANGE_MTOKNA_PRODUCT_STATUS = 'change_mtokna_product_status';
export const DELETE_MTOKNA_PRODUCT = 'delete_mtokna_product';
// Mtokna schemes
export const FETCH_MTOKNA_SCHEMES = 'fetch_mtokna_schemes';
export const CLEAN_MTOKNA_SCHEMES = 'clean_mtokna_schemes';
export const CHANGE_MTOKNA_SCHEME = 'change_mtokna_scheme';
export const DELETE_MTOKNA_SCHEME = 'delete_mtokna_scheme';
// Mtokna window settings
export const FETCH_MTOKNA_WINDOW_SETTINGS = 'fetch_mtokna_window_settings';
export const CLEAN_MTOKNA_WINDOW_SETTINGS = 'clean_mtokna_window_settings';
// Mtokna window seller
export const FETCH_MTOKNA_WINDOW_SELLER = 'fetch_mtokna_window_seller';
export const CLEAN_MTOKNA_WINDOW_SELLER = 'clean_mtokna_window_seller';
// Mtokna windows
export const FETCH_MTOKNA_WINDOWS = 'fetch_mtokna_windows';
export const CLEAN_MTOKNA_WINDOWS = 'clean_mtokna_windows';
export const EDIT_MTOKNA_WINDOW = 'edit_mtokna_window';
export const DELETE_MTOKNA_WINDOW = 'delete_mtokna_window';
export const CHANGE_MTOKNA_WINDOW_STATE = 'change_mtokna_window_state';
export const READY_PICKUP_MTOKNA_WINDOW = 'ready_pickup_mtokna_window';
export const PICKUP_MTOKNA_WINDOW = 'pickup_mtokna_window';
export const ACTIVATE_MTOKNA_WINDOW = 'activate_mtokna_window';
// Mtokna documents
export const FETCH_MTOKNA_DOCUMENTS = 'fetch_mtokna_documents';
export const CLEAN_MTOKNA_DOCUMENTS = 'clean_mtokna_documents';
export const DELETE_MTOKNA_DOCUMENT = 'delete_mtokna_document';
// Mtokna videos
export const FETCH_MTOKNA_VIDEOS = 'fetch_mtokna_videos';
export const CLEAN_MTOKNA_VIDEOS = 'clean_mtokna_videos';
export const DELETE_MTOKNA_VIDEO = 'delete_mtokna_video';
// Mtokna dogs
export const FETCH_MTOKNA_DOGS = 'fetch_mtokna_dogs';
export const CLEAN_MTOKNA_DOGS = 'clean_mtokna_dogs';
export const CHANGE_MTOKNA_DOG = 'change_mtokna_dog';
export const DELETE_MTOKNA_DOG = 'delete_mtokna_dog';
// Mtokna dog products
export const FETCH_MTOKNA_DOG_PRODUCTS = 'fetch_mtokna_dog_products';
export const CLEAN_MTOKNA_DOG_PRODUCTS = 'clean_mtokna_dog_products';
export const CHANGE_MTOKNA_DOG_PRODUCT = 'change_mtokna_dog_product';
export const DELETE_MTOKNA_DOG_PRODUCT = 'delete_mtokna_dog_product';
// Rainpro orders
export const FETCH_RAINPRO_ORDERS = 'fetch_rainpro_orders';
export const CLEAN_RAINPRO_ORDERS = 'clean_rainpro_orders';
export const SYNC_RAINPRO_ORDER = 'sync_rainpro_order';
export const EDIT_RAINPRO_ORDER = 'edit_rainpro_order';
export const PICKER_RAINPRO_ORDER = 'picker_rainpro_order';
export const SEND_RAINPRO_ORDERS = 'send_rainpro_orders';
export const CHANGE_RAINPRO_ORDER_STATE = 'change_rainpro_order_state';
// Rainpro pickers
export const FETCH_RAINPRO_PICKERS = 'fetch_rainpro_pickers';
export const CLEAN_RAINPRO_PICKERS = 'clean_rainpro_pickers';
export const CHANGE_RAINPRO_PICKER_EMAIL = 'change_rainpro_picker_email';
export const CHANGE_RAINPRO_PICKER_SETTINGS = 'change_rainpro_picker_settings';
// Mtokna excel schemes
export const FETCH_MTOKNA_EXCEL_SCHEMES = 'fetch_mtokna_excel_schemes';
export const CLEAN_MTOKNA_EXCEL_SCHEMES = 'clean_mtokna_excel_schemes';
export const CHANGE_MTOKNA_EXCEL_SCHEME = 'change_mtokna_excel_scheme';
export const DELETE_MTOKNA_EXCEL_SCHEME = 'delete_mtokna_excel_scheme';
// Cab orders
export const FETCH_CAB_ORDERS = 'fetch_cab_orders';
export const CLEAN_CAB_ORDERS = 'clean_cab_orders';
export const SYNC_CAB_ORDER = 'sync_cab_order';
export const EDIT_CAB_ORDER = 'edit_cab_order';
export const CHANGE_CAB_ORDER_STATE = 'change_cab_order_state';
export const EXPORT_CAB_ORDER = 'export_cab_order';
export const CREATE_CAB_INVOICE = 'create_cab_invoice';
export const CREATE_CAB_INVOICES = 'create_cab_invoices';
export const PAID_CAB_ORDER = 'paid_cab_order';
export const PAID_CAB_ORDERS = 'paid_cab_orders';
export const SEND_CAB_ORDERS = 'send_cab_orders';
// Points
export const FETCH_POINTS = 'fetch_points';
export const CLEAN_POINTS = 'clean_points';
export const DELETE_POINT = 'delete_point';
// Files
export const FETCH_FILES = 'fetch_files';
export const CLEAN_FILES = 'clean_files';
export const DELETE_FILE = 'delete_file';
// AI functions
export const FETCH_AI_FUNCTIONS = 'fetch_ai_functions';
export const CLEAN_AI_FUNCTIONS = 'clean_ai_functions';
export const DELETE_AI_FUNCTION = 'delete_ai_function';
// AI commands
export const FETCH_AI_COMMANDS = 'fetch_ai_commands';
export const CLEAN_AI_COMMANDS = 'clean_ai_commands';
export const COMMENT_AI_COMMAND = 'comment_ai_command';
export const DELETE_AI_COMMAND = 'delete_ai_command';
export const RUN_AI_COMMAND = 'run_ai_command';
// AI command items
export const FETCH_AI_COMMAND_ITEMS = 'fetch_ai_command_items';
export const CLEAN_AI_COMMAND_ITEMS = 'clean_ai_command_items';
export const RUN_AI_COMMAND_ITEM = 'run_ai_command_item';
export const RUN_AI_COMMAND_ITEMS = 'run_ai_command_items';
export const DELETE_AI_COMMAND_ITEM = 'delete_ai_command_item';
export const DELETE_AI_COMMAND_ITEMS = 'delete_ai_command_items';
export const EXPORT_AI_COMMAND_ITEMS = 'export_ai_command_items';
export const EDIT_AI_COMMAND_ITEM = 'edit_ai_command_item';
export const EDIT_AI_COMMAND_ITEMS = 'edit_ai_command_items';
export const SAVE_AI_COMMAND_ITEMS = 'save_ai_command_items';
// Products
export const FETCH_FULL_PRODUCTS = 'fetch_full_products';
export const CLEAN_FULL_PRODUCTS = 'clean_full_products';
export const DELETE_FULL_PRODUCT = 'delete_full_product';
export const DELETE_FULL_PRODUCTS = 'delete_full_products';
// AI addons
export const FETCH_AI_ADDONS = 'fetch_ai_addons';
export const CLEAN_AI_ADDONS = 'clean_ai_addons';
// AI chatbot questions
export const FETCH_AI_CHATBOT_QUESTIONS = 'fetch_ai_chatbot_questions';
export const CLEAN_AI_CHATBOT_QUESTIONS = 'clean_ai_chatbot_questions';
export const EDIT_AI_CHATBOT_QUESTION = 'edit_ai_chatbot_question';
export const DELETE_AI_CHATBOT_QUESTION = 'delete_ai_chatbot_question';
export const DELETE_AI_CHATBOT_QUESTIONS = 'delete_ai_chatbot_questions';
// AI chatbot threads
export const FETCH_AI_CHATBOT_THREADS = 'fetch_ai_chatbot_threads';
export const CLEAN_AI_CHATBOT_THREADS = 'clean_ai_chatbot_threads';
export const DELETE_AI_CHATBOT_THREAD = 'delete_ai_chatbot_thread';
export const DELETE_AI_CHATBOT_THREADS = 'delete_ai_chatbot_threads';
export const CHANGE_AI_CHATBOT_THREAD_COMMENT = 'change_ai_chatbot_thread_comment';
// Categories
export const FETCH_CATEGORIES = 'fetch_categories';
export const CLEAN_CATEGORIES = 'clean_categories';
export const DELETE_CATEGORY = 'delete_category';
export const DELETE_CATEGORIES = 'delete_categories';
// AI transactions
export const FETCH_AI_TRANSACTIONS = 'fetch_ai_transactions';
export const CLEAN_AI_TRANSACTIONS = 'clean_ai_transactions';
// AI mailer questions
export const FETCH_AI_MAILER_QUESTIONS = 'fetch_ai_mailer_questions';
export const CLEAN_AI_MAILER_QUESTIONS = 'clean_ai_mailer_questions';
export const EDIT_AI_MAILER_QUESTION = 'edit_ai_mailer_question';
export const DELETE_AI_MAILER_QUESTION = 'delete_ai_mailer_question';
export const DELETE_AI_MAILER_QUESTIONS = 'delete_ai_mailer_questions';
// AI mailer threads
export const FETCH_AI_MAILER_THREADS = 'fetch_ai_mailer_threads';
export const CLEAN_AI_MAILER_THREADS = 'clean_ai_mailer_threads';
export const DELETE_AI_MAILER_THREAD = 'delete_ai_mailer_thread';
export const DELETE_AI_MAILER_THREADS = 'delete_ai_mailer_threads';
export const IGNORE_AI_MAILER_THREAD = 'ignore_ai_mailer_thread';
export const UNIGNORE_AI_MAILER_THREAD = 'unignore_ai_mailer_thread';
// Eshop enums
export const FETCH_ESHOP_ENUMS = 'fetch_eshop_enums';
export const CLEAN_ESHOP_ENUMS = 'clean_eshop_enums';
// Mtokna codes
export const FETCH_MTOKNA_CODES = 'fetch_mtokna_codes';
export const CLEAN_MTOKNA_CODES = 'clean_mtokna_codes';
export const CHANGE_MTOKNA_CODE = 'change_mtokna_code';
export const DELETE_MTOKNA_CODE = 'delete_mtokna_code';
// Rainpro products
export const FETCH_RAINPRO_PRODUCTS = 'fetch_rainpro_products';
export const CLEAN_RAINPRO_PRODUCTS = 'clean_rainpro_products';
export const CHANGE_RAINPRO_PRODUCT_STATUS = 'change_rainpro_product_status';
export const CHANGE_RAINPRO_PRODUCTS_STATUS = 'change_rainpro_products_status';
export const DELETE_RAINPRO_PRODUCT = 'delete_rainpro_product';
export const DELETE_RAINPRO_PRODUCTS = 'delete_rainpro_products';
// Rainpro storages
export const FETCH_RAINPRO_STORAGES = 'fetch_rainpro_storages';
export const CLEAN_RAINPRO_STORAGES = 'clean_rainpro_storages';
export const CHANGE_RAINPRO_STORAGE = 'change_rainpro_storage';
export const DELETE_RAINPRO_STORAGE = 'delete_rainpro_storage';
// Rainpro storage items
export const FETCH_RAINPRO_STORAGE_ITEMS = 'fetch_rainpro_storage_items';
export const CLEAN_RAINPRO_STORAGE_ITEMS = 'clean_rainpro_storage_items';
export const CHANGE_RAINPRO_STORAGE_ITEM = 'change_rainpro_storage_item';
export const DELETE_RAINPRO_STORAGE_ITEM = 'delete_rainpro_storage_item';
export const DELETE_RAINPRO_STORAGE_ITEMS = 'delete_rainpro_storage_items';
// Rainpro storage logs
export const FETCH_RAINPRO_STORAGE_LOGS = 'fetch_rainpro_storage_logs';
export const CLEAN_RAINPRO_STORAGE_LOGS = 'clean_rainpro_storage_logs';
// Rainpro schemes
export const FETCH_RAINPRO_SCHEMES = 'fetch_rainpro_schemes';
export const CLEAN_RAINPRO_SCHEMES = 'clean_rainpro_schemes';
export const CHANGE_RAINPRO_SCHEME = 'change_rainpro_scheme';
export const DELETE_RAINPRO_SCHEME = 'delete_rainpro_scheme';
// DropXL logs
export const FETCH_DROPXL_LOGS = 'fetch_dropxl_logs';
export const CLEAN_DROPXL_LOGS = 'clean_dropxl_logs';
// Rainpro sellers
export const FETCH_RAINPRO_SELLERS = 'fetch_rainpro_sellers';
export const CLEAN_RAINPRO_SELLERS = 'clean_rainpro_sellers';
export const CHANGE_RAINPRO_SELLER_EMAIL = 'change_rainpro_seller_email';
export const CHANGE_RAINPRO_SELLER_SETTINGS = 'change_rainpro_seller_settings';
// Rainpro points
export const FETCH_RAINPRO_POINTS = 'fetch_rainpro_points';
export const CLEAN_RAINPRO_POINTS = 'clean_rainpro_points';
export const CHANGE_RAINPRO_POINT = 'change_rainpro_point';
export const DELETE_RAINPRO_POINT = 'delete_rainpro_point';
// Rainpro seller orders
export const FETCH_RAINPRO_SELLER_ORDERS = 'fetch_rainpro_seller_orders';
export const CLEAN_RAINPRO_SELLER_ORDERS = 'clean_rainpro_seller_orders';
export const SYNC_RAINPRO_SELLER_ORDER = 'sync_rainpro_seller_order';
export const EDIT_RAINPRO_SELLER_ORDER = 'edit_rainpro_seller_order';
export const CHANGE_RAINPRO_SELLER_ORDER_STATE = 'change_rainpro_seller_order_state';
export const PICKUP_RAINPRO_SELLER_ORDER = 'pickup_rainpro_seller_order';
export const READY_RAINPRO_SELLER_ORDER = 'ready_rainpro_seller_order';
// Mtokna campaigns
export const FETCH_MTOKNA_CAMPAIGNS = 'fetch_mtokna_campaigns';
export const CLEAN_MTOKNA_CAMPAIGNS = 'clean_mtokna_campaigns';
export const DELETE_MTOKNA_CAMPAIGN = 'delete_mtokna_campaign';
// Email
export const FETCH_MTOKNA_CAMPAIGN_TEMPLATE = 'fetch_mtokna_campaign_template';
export const CLEAN_MTOKNA_CAMPAIGN_TEMPLATE = 'clean_mtokna_campaign_template';
// Mtokna contacts
export const FETCH_MTOKNA_CONTACTS = 'fetch_mtokna_contacts';
export const CLEAN_MTOKNA_CONTACTS = 'clean_mtokna_contacts';
export const DELETE_MTOKNA_CONTACT = 'delete_mtokna_contact';
export const UNSUBSCRIBE_MTOKNA_CONTACT = 'unsubscribe_mtokna_contact';
export const SUBSCRIBE_MTOKNA_CONTACT = 'subscribe_mtokna_contact';
export const SEND_CONTACTS = 'send_contacts';
// Mtokna seller complaints
export const FETCH_MTOKNA_SELLER_COMPLAINTS = 'fetch_mtokna_seller_complaints';
export const CLEAN_MTOKNA_SELLER_COMPLAINTS = 'clean_mtokna_seller_complaints';
export const CHANGE_MTOKNA_SELLER_COMPLAINT_STATE = 'change_mtokna_seller_complaint_state';
// Stitky
export const FETCH_RAINPRO_LABELS = 'fetch_rainpro_labels';
export const CLEAN_RAINPRO_LABELS = 'clean_rainpro_labels';
export const DOWNLOAD_RAINPRO_LABEL = 'download_rainpro_label';
// Esat schemes
export const FETCH_ESAT_SCHEMES = 'fetch_esat_schemes';
export const CLEAN_ESAT_SCHEMES = 'clean_esat_schemes';
export const CHANGE_ESAT_SCHEME = 'change_esat_scheme';
export const DELETE_ESAT_SCHEME = 'delete_esat_scheme';
// Esat products
export const FETCH_ESAT_PRODUCTS = 'fetch_esat_products';
export const CLEAN_ESAT_PRODUCTS = 'clean_esat_products';
export const DELETE_ESAT_PRODUCT = 'delete_esat_product';
export const DELETE_ESAT_PRODUCTS = 'delete_esat_products';
export const PREPARE_ESAT_PRODUCT = 'prepare_esat_product';
export const SEND_ESAT_PRODUCT = 'send_esat_product';
export const SEND_ESAT_PRODUCTS = 'send_esat_products';
export const REMOVE_ESAT_PRODUCT = 'remove_esat_product';
// Mtokna owner points
export const FETCH_MTOKNA_OWNER_POINTS = 'fetch_mtokna_owner_points';
export const CLEAN_MTOKNA_OWNER_POINTS = 'clean_mtokna_owner_points';
export const CREATE_MTOKNA_OWNER_POINT = 'create_mtokna_owner_point';
export const DELETE_MTOKNA_OWNER_POINT = 'delete_mtokna_owner_point';
// Mtokna seller notes
export const FETCH_MTOKNA_SELLER_NOTES = 'fetch_mtokna_seller_notes';
export const CLEAN_MTOKNA_SELLER_NOTES = 'clean_mtokna_seller_notes';
export const CHANGE_MTOKNA_SELLER_NOTE = 'change_mtokna_seller_note';
export const DELETE_MTOKNA_SELLER_NOTE = 'delete_mtokna_seller_note';
// AI agents
export const FETCH_AI_AGENTS = 'fetch_ai_agents';
export const CLEAN_AI_AGENTS = 'clean_ai_agents';
export const DELETE_AI_AGENT = 'delete_ai_agent';
export const RUN_AI_AGENT = 'run_ai_agent';
export const PAUSE_AI_AGENT = 'pause_ai_agent';
// AI agent commands
export const FETCH_AI_AGENT_COMMANDS = 'fetch_ai_agent_commands';
export const CLEAN_AI_AGENT_COMMANDS = 'clean_ai_agent_commands';
// Rainpro point packages
export const FETCH_RAINPRO_POINT_PACKAGES = 'fetch_rainpro_point_packages';
export const CLEAN_RAINPRO_POINT_PACKAGES = 'clean_rainpro_point_packages';
// Mtokna manual invoices
export const FETCH_MTOKNA_MANUAL_INVOICES = 'fetch_mtokna_manual_invoices';
export const CLEAN_MTOKNA_MANUAL_INVOICES = 'clean_mtokna_manual_invoices';
export const PAID_MTOKNA_MANUAL_INVOICE = 'paid_mtokna_manual_invoice';
export const CHANGE_MTOKNA_MANUAL_INVOICE_SETTINGS = 'change_mtokna_manual_invoice_settings';
// Rainpro complaint orders
export const FETCH_RAINPRO_COMPLAINT_ORDERS = 'fetch_rainpro_complaint_orders';
export const CLEAN_RAINPRO_COMPLAINT_ORDERS = 'clean_rainpro_complaint_orders';
export const EDIT_RAINPRO_COMPLAINT_ORDER = 'edit_rainpro_complaint_order';
export const SEND_RAINPRO_COMPLAINT_ORDERS = 'send_rainpro_complaint_orders';
export const SYNC_RAINPRO_COMPLAINT_ORDER = 'sync_rainpro_complaint_order';
export const PICKER_RAINPRO_COMPLAINT_ORDER = 'picker_rainpro_complaint_order';
// Jokl users
export const FETCH_JOKL_USERS = 'fetch_jokl_users';
export const CLEAN_JOKL_USERS = 'clean_jokl_users';
export const CHANGE_JOKL_USER_STATUS = 'change_jokl_user_status';
// Jokl credits
export const FETCH_JOKL_CREDITS = 'fetch_jokl_credits';
export const CLEAN_JOKL_CREDITS = 'clean_jokl_credits';
// Jokl orders
export const FETCH_JOKL_ORDERS = 'fetch_jokl_orders';
export const CLEAN_JOKL_ORDERS = 'clean_jokl_orders';
export const SET_JOKL_ORDER_PAID = 'set_jokl_order_paid';
export const SET_JOKL_ORDER_PROCESSED = 'set_jokl_order_processed';
export const DELETE_JOKL_ORDER = 'delete_jokl_order';
// Jokl coupons
export const FETCH_JOKL_COUPONS = 'fetch_jokl_coupons';
export const CLEAN_JOKL_COUPONS = 'clean_jokl_coupons';
export const SET_JOKL_COUPON_PROCESSED = 'set_jokl_coupon_processed';
export const DELETE_JOKL_COUPON = 'delete_jokl_coupon';
